import {Bone,MathUtils,Quaternion,Vector3} from 'three';

export const WALL_CATCH_TIME=.22;

/** Carry the finished airborne/grounded pose into the authored wall loop.
 * This runs after contact ownership changes, so retiring ground IK or the
 * jump tuck cannot uncover a different leg pose on the first attached frame. */
export class WallRunTransition {
  private readonly pose:{bone:Bone;rotation:Quaternion;position:Vector3;delay:number}[]=[];
  private readonly target=new Quaternion();
  elapsed=WALL_CATCH_TIME;
  get active():boolean{return this.elapsed<WALL_CATCH_TIME;}
  get progress():number{return MathUtils.clamp(this.elapsed/WALL_CATCH_TIME,0,1);}
  begin(bones:readonly Bone[]):void {
    this.pose.length=0;
    for(const bone of bones){
      if(!/^(pelvis|spine_|neck_|head|clavicle_|upperarm_|lowerarm_|hand_|thigh_|calf_|foot_|ball_)/.test(bone.name))continue;
      // Shoulders reach first, followed by the hips and the planting foot.
      const delay=/^(thigh_|calf_|foot_|ball_)/.test(bone.name)?.018:0;
      this.pose.push({bone,rotation:bone.quaternion.clone(),position:bone.position.clone(),delay});
    }
    this.elapsed=0;
  }
  cancel():void{this.elapsed=WALL_CATCH_TIME;this.pose.length=0;}
  apply(dt:number):void {
    if(!this.active)return;
    this.elapsed=Math.min(WALL_CATCH_TIME,this.elapsed+Math.max(0,Number.isFinite(dt)?dt:0));
    for(const {bone,rotation,position,delay}of this.pose){
      const weight=MathUtils.smootherstep(this.elapsed,delay,WALL_CATCH_TIME);
      this.target.copy(bone.quaternion);bone.quaternion.slerpQuaternions(rotation,this.target,weight);
      if(bone.name==='pelvis')bone.position.lerpVectors(position,bone.position,weight);
    }
    if(!this.active)this.pose.length=0;
  }
}
